import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideSeparatorBlockData from '../../../Models/Content/GenericGuideSeparatorBlockData';
import GenericGuideSeparator from './GenericGuideSeparatorBlock';

export default class GenericGuideSeparatorBlock extends EpiComponent<GenericGuideSeparatorBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-separator-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideSeparator iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

